<div class="page-wraper">

    <!-- HEADER START -->
    <app-header1></app-header1>
    <!-- HEADER END -->


    <!-- CONTENT START -->
    <div class="page-content ">

        <app-page-banner class="small-banner"  title="School Mental Health Program" subtitle="School Mental Health Program" ></app-page-banner>
       <div class="container"> 
<!--        
        <div class="row align-items-center ">
            <div class="col-lg-6 col-md-12 m-b10">
                <div class="image-container text-center">
                    <img src="assets/images/smvission.jpg" alt="Welcome to Soul Space" class="img-fluid rounded-img shadow-img">
                </div>
            </div>
        
            <div class="col-lg-6 col-md-12">
                <div class="text-content">
                    <div class="separator-line mb-4"></div>
                    <h5>Our Vision </h5>
                    <p >
                        At Soul Space, we envision a future where every school is equipped with the tools and knowledge to support students' mental health effectively. We aim to:
                    </p>
                        <ul class="centered-list">
                            <li>Reduce stigma around mental health in educational settings.</li>
                            <li>Empower students with self-awareness and emotional regulation skills.</li>
                            <li>Provide early intervention and support for mental health challenges.</li>
                            <li>Foster a culture of empathy and understanding in school.</li>
                            <li>Equip educators with the resources to support students' emotional needs.</li>
                        </ul>
        

                    
        
                    
                </div>
            </div>
        </div> -->
        
        </div>
              

    </div>

    <!-- <div class="page-content">

        
       <div class="container">
        <div class="row align-items-center ">
            <div class="col-lg-6 col-md-12 m-b10">
                <div class="image-container text-center mt-5 mb-4">
                    <img src="assets/images/sm1.jpg" alt="Welcome to Soul Space" class="img-fluid rounded-img shadow-img">
                </div>
            </div>
        
            <div class="col-lg-6 col-md-12">
                <div class="text-content">
                    <div class="separator-line mb-4"></div>
                    <h5>Our Mission </h5>
                    <p class="section-body">
                        At Soul Space, we believe that every student deserves a safe and nurturing environment to explore their emotions, develop resilience, and cultivate mental well being. Our mission is to transform schools into havens of emotional growth and self-discovery

                    </p>
        
                    
                </div>
            </div>
        </div>
    </div>
        
              

    </div> -->

    <!-- <div class="page-content">

        <div class="container">

            <div class="row align-items-center ">
                <div class="col-lg-6 col-md-12 m-b10">
                    <div class="image-container text-center">
                        <img src="assets/images/impact.jpg" alt="Welcome to Soul Space"
                            class="img-fluid rounded-img shadow-img">
                    </div>
                </div>

                <div class="col-lg-6 col-md-12">
                    <div class="text-content">
                        <div class="separator-line mb-4"></div>
                        <h5>Our Impact
                        </h5>
                        <p>
                            Since our inception, Soul Space has
                        <p>
                        <ul class="centered-list">
                            <li>Reduce stigma around mental health in educational settings.</li>
                            <li>Empower students with self-awareness and emotional regulation skills.</li>
                            <li>Provide early intervention and support for mental health challenges.</li>
                            <li>Foster a culture of empathy and understanding in school.</li>
                            <li>Equip educators with the resources to support students' emotional needs.</li>
                        </ul>
                        <p>
                            We're proud of our achievements, but we're just getting started. Join us in our mission to
                            create a world where every student has the emotional tools they need to thrive in this
                            challenging world

                        </p>


                    </div>
                </div>
            </div>

        </div>


    </div> -->
<!-- 
    <div class="page-content">

    


       <div class="container">
                
                <div class="row align-items-center ">
                    <div class="col-lg-6 col-md-12 m-b10">
                        <div class="image-container text-center">
                            <img src="assets/images/sm2.jpg" alt="Welcome to Soul Space" class="img-fluid rounded-img shadow-img">
                        </div>
                    </div>
                
                    <div class="col-lg-6 col-md-12">
                        <div class="text-content">
                            <div class="separator-line mb-4"></div>
                            <h5>Our Unique Approach
                            </h5>
                            <p >
                                Soul Space integrates cutting-edge technology with time-honored mindfulness practices to create a holistic mental health program:
                            </p>
                                <ul class="centered-list">
                                    <li>Virtual Reality Meditation Pods Immersive experiences tailored to individual emotional needs.</li>
                                    <li>AI-Powered Emotion Recognition Real-time support based on facial expressions and voice patterns.</li>
                                    <li>Biofeedback Wearables Helping students understand and regulate their physiological responses to stress.</li>
                                    <li>Peer Support Networks Fostering connections and empathy among students.</li>
                                </ul>
                
                            
                        </div>
                    </div>
                </div>
            </div>

    </div> -->

    <div class="page-content">

        <!-- INNER PAGE BANNER -->
        <!-- INNER PAGE BANNER END -->


       <div class="container pb-5">
                
                <div class="row align-items-center ">
                    <!-- Left Side: Image -->

                    <div class="col-lg-6 col-md-6">
                        <div class="text-content mb-4">
                            
                            <h5>Program Overview:</h5>
                            <p>Our Evidence based methodology for holistic wellness.</p>

                            <p><b>Techniques and methods used for evaluations & interventions</b></p>

                            <p>Psychological Evaluations:</p>
                           <ul class="centered-list">
                            <li>Use of scientifically validated tools and assessments.</li>
                            <li>Behavioral observations to identify patterns and triggers.</li>
                            <li>Structured interviews and surveys.</li>
                            <li>Comprehensive data gathering and analysis.</li>
                           </ul> 
                           

                            <p>Regular Interventions:</p>
                           <ul class="centered-list">
                            <li>Counseling sessions by trained psychologists.</li>
                            <li>Cognitive Behavioral Therapy (CBT).</li>
                            <li>Mindfulness and relaxation exercises.</li>
                            <li>Workshops on emotional regulation and seminars.</li></ul>
                            </div>
                            </div>
                            <div class="col-lg-6 col-md-12">
                                <div class="about-image">
                                    
        
                                    <img src="assets/images/happy-football-children-relax-on-field-sports-port-2023-11-27-05-17-32-utc.jpg" alt="About Soul Space" class="img-fluid" style="
                                    height: 450px;
                                    width: 100%;
                                    position: relative;
                                    bottom: 12px;
                                ">
                                </div>
                             
        
                            </div>
                
                    <!-- Right Side: Text Content -->
                    <div class="col-lg-12 col-md-12">
                        <div class="text-content">
                            <p >
                                The School Mental Health Program at Soul Space is a 3-months comprehensive initiative designed to support the overall well-being of students between the age of 12 to 17 years. The program, taking a holistic approach, goes beyond the classroom, focusing on the mental, emotional, physical and social health of students to empower them to thrive academically and personally.
                            </p>
                            <h5>Here are some key elements of the program:
                            </h5>
                            <p>
                                <b>Student- Centric Approach -</b> Tailored workshops and interactive activities designed to
                                boost self-confidence, counseling sessions to foster self-awareness, emotional
                                resilience and promote healthy coping skills. Equipping students with stress
                                management skills and promoting healthy living habits.</p>

                               <p> <b>Equipping and Supporting Teachers -</b> Specialized training, wellness tools and
                                practical resources for the educators to help them connect better with the students,
                                understand their needs and equip them with the necessary skills fostering student
                                and educator's well-being.</p>
                                <p> <b>Engaging Parents - </b>Insightful and interactive sessions, guidance and resources for
                                parents to empower their role as a parent in supporting their child’s growth and
                                emotional well-being.</p>
                                <p> <b>Transforming Schools -</b> A unified approach aimed at creating a positive school
                                environment that brings together the entire school community, fostering a culture of
                                kindness, inclusivity and shared growth.
                                Through our School Mental Health Program, we aim to create a movement to
                                redefine wellness in schools to create a nurturing environment that prioritizes overall
                                health and development.</p>

                                <!-- <p>Our Services section needs to be renamed as Features of School Mental Health
                                Program and the following details should come under this section.</p> -->
                                <h5>Features of School Mental Health Program:</h5>
                                <ul class="centered-list">
                                    <li>Psychological Assessments.</li>
                                    <li>Individual and Group Counseling.</li>
                                    <li>Peer Support and Mentoring.</li>
                                    <li>Workshops and Interactive Sessions.</li>
                                    <li>Teacher Training Program.</li>
                                    <li>Parent Training Program.</li>
                                </ul>

                                <h5>Program Offerings for Students:</h5>
                
                                <ul class="centered-list">
                                    <li> <b>Resilience Building:</b> Strengthen emotional awareness and self-regulation
                                through engaging activities.</li>
                                <li> <b>Stress Management:</b> Master techniques like mindfulness, yoga, and
                                Pomodoro for better focus.</li>
                                <li><b>Creative Expression:</b> Reduce stress with art, dance therapy, and interactive
                                games.</li>
                                <li><b>Holistic Wellness:</b> Promote mental and physical health with nutrition education
                                and gratitude exercises.</li> 
                                <li> <b>Career Readiness:</b> Develop essential skills like journaling, time management,
                                and goal setting.</li>
                                <li>  <b>Measurable Growth:</b> Assess progress with pre- and post-program evaluations.</li>
                                <li> <b>Safe Spaces:</b> Provide secure environments, peer support, and helplines for
                                ongoing care.</li>

                               <!-- <p><span style="margin-left: 21px;">“Our Evidence based methodology for holistic wellness"</span>
                                <br>
                                <span style="margin-left: 25px;"> Techniques and methods used for evaluations & interventions</span>
                                <br>
                                <span style="margin-left: 25px;">Psychological Evaluations:</span></p> 
                                <li> Use of scientifically validated tools and assessments.</li>
                                <li> Behavioral observations to identify patterns and triggers.</li>
                                <li> Structured interviews and surveys.</li>
                                <li> Comprehensive data gathering and analysis.</li>
                                <li>Regular Interventions:</li>
                                <li> Counseling sessions by trained psychologists.</li>
                                <li> Cognitive Behavioral Therapy (CBT).</li>
                                <li> Mindfulness and relaxation exercises.</li>
                                <li>  Workshops on emotional regulation and seminars.</li> -->
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

    </div>


    
    <!-- CONTENT END -->

    <app-footer1></app-footer1>

</div>

<app-loader></app-loader>